import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@lt/localization';
import Icon from '../Icon';
import EmptyBlock from '../../routes/HotelReviewsPage/components/EmptyBlock';

const EmptyReviews = ({ isMobile = false }) => {
  const { t } = useTranslation();
  return (
    <EmptyBlock
      isMobile={isMobile}
      icon={
        <StyledEmptyReviewsIcon
          type="empty-search-reviews"
          width="166px"
          isMobile={isMobile}
        />
      }
      title={t('hotel.reviews.emptyTitle')}
      subtitle={t('hotel.reviews.emptySubtitle')}
    />
  );
};

const StyledEmptyReviewsIcon = styled(Icon)`
  path[name='empty-search-reviews-stars'] {
    fill: ${(props) => (props.isMobile ? '#f2f2f2' : props.theme.colors.white)};
  }
`;

export default EmptyReviews;
